import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent as NgPageEvent } from '@angular/material/paginator';
import { Subscription as RxSubscription } from 'rxjs';
import { BranchDataSource } from '../../services/branch-data-source';

@Component({
    selector: 'branch-picker-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class BranchEventPicker implements OnInit, OnDestroy {
  public selectedBranch;
  public displayedColumns = ['title', 'actions'];
  public loading: boolean = false;
  public PageEvent: NgPageEvent;
  private Subscriptions: RxSubscription[] = [];
  public branch;

  constructor(
    private DialogRef: MatDialogRef<BranchEventPicker>,
    @Inject(MAT_DIALOG_DATA) public DataSource: BranchDataSource
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (PageEvent) => (this.PageEvent = PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (branches) => (this.branch = branches[0])
      )
    );
    this.load(this.PageEvent);
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }

  public load(PageEvent: NgPageEvent) {
    this.DataSource.loadWithPageEvent(PageEvent);
  }

  public setSelectedBranch(id: number) {
    this.selectedBranch = this.selectedBranch.id !== id ? id : null;
  }

  public selectBranch(option?) {
    if (option === 'notBranchEvent') {
      this.DialogRef.close();
    } else {
      this.DialogRef.close(this.branch);
    }
  }
}
